import React from 'react';

import LocalizedLink from 'components/LocalizedLink';
import { useI18n } from 'i18n/I18nContext';
import * as Icons from 'static/images/icons';

const AiAssistantIcon = () => (
  <svg viewBox="0 0 64 64" aria-hidden>
    <circle cx="32" cy="32" r="30" fill="none" stroke="currentColor" strokeWidth="2" />
    <path
      fill="currentColor"
      d="M32 18c-6.5 0-11 4.2-11 10.2 0 4.5 2.4 7.8 6 9.4V42c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-4.4c3.6-1.6 6-4.9 6-9.4C43 22.2 38.5 18 32 18zm-1 26h2v2h-2v-2z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      d="M20 14l3 3M44 14l-3 3M32 12v4"
    />
  </svg>
);

const FacilityIcon = () => (
  <svg viewBox="0 0 64 64" aria-hidden>
    <rect
      x="10"
      y="18"
      width="44"
      height="34"
      rx="3"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M10 28h44" stroke="currentColor" strokeWidth="2" />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      d="M22 38l6 6 14-14"
    />
    <path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" d="M32 10v8" />
  </svg>
);

const WebDashboardIcon = () => (
  <svg viewBox="0 0 64 64" aria-hidden>
    <rect
      x="8"
      y="12"
      width="48"
      height="34"
      rx="3"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M8 22h48" stroke="currentColor" strokeWidth="2" />
    <circle cx="14" cy="17" r="2" fill="currentColor" />
    <circle cx="20" cy="17" r="2" fill="currentColor" />
    <circle cx="26" cy="17" r="2" fill="currentColor" />
    <rect x="22" y="50" width="20" height="4" rx="1" fill="currentColor" />
    <path d="M14 46h36v4H14z" fill="currentColor" />
  </svg>
);

const HomeModules = () => {
  const { t } = useI18n();
  const modules = [
    {
      key: 'ai',
      icon: <AiAssistantIcon />,
      title: t('home.modules.aiTitle'),
      body: t('home.modules.aiBody'),
    },
    {
      key: 'tasklist',
      icon: Icons.tasklistIcon,
      title: t('home.modules.tasklistTitle'),
      body: t('home.modules.tasklistBody'),
    },
    {
      key: 'cash',
      icon: Icons.cashregisterIcon,
      title: t('home.modules.cashTitle'),
      body: t('home.modules.cashBody'),
    },
    {
      key: 'recipes',
      icon: Icons.dishIcon,
      title: t('home.modules.recipesTitle'),
      body: t('home.modules.recipesBody'),
    },
    {
      key: 'dashboard',
      icon: <WebDashboardIcon />,
      title: t('home.modules.dashboardTitle'),
      body: t('home.modules.dashboardBody'),
    },
    {
      key: 'mep',
      icon: Icons.MEPIcon,
      title: t('home.modules.mepTitle'),
      body: t('home.modules.mepBody'),
    },
    {
      key: 'facility',
      icon: <FacilityIcon />,
      title: t('home.modules.facilityTitle'),
      body: t('home.modules.facilityBody'),
    },
    {
      key: 'whiteboard',
      icon: Icons.whiteboardIcon,
      title: t('home.modules.whiteboardTitle'),
      body: t('home.modules.whiteboardBody'),
    },
  ];

  return (
    <section className="gb-home-section gb-home-modules" aria-labelledby="gb-modules-heading">
      <div className="container gb-home-section__inner">
        <div className="gb-modules-layout">
          <header className="gb-modules-layout__intro">
            <h2 id="gb-modules-heading" className="gb-home-section__title">
              {t('home.modulesTitle')}
            </h2>
            <p className="gb-home-section__lede m-0">{t('home.modulesLede')}</p>
            <LocalizedLink to="/for" className="gb-modules-layout__link">
              {t('home.forLink')}
            </LocalizedLink>
          </header>

          <ul className="gb-module-list m-0 p-0">
            {modules.map((mod) => (
              <li key={mod.key} className="gb-module-row">
                <div className="gb-module-row__icon" aria-hidden>
                  <span className="gb-icon-slot gb-icon-slot--sm">{mod.icon}</span>
                </div>
                <div className="gb-module-row__copy">
                  <h3 className="gb-module-row__title m-0">{mod.title}</h3>
                  <p className="gb-module-row__body m-0">{mod.body}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default HomeModules;



// WEBPACK FOOTER //
// ./src/components/home/HomeModules.tsx